import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';  // Importation de useLocation pour récupérer l'URL
import { db } from '../../firebase';
import { collection, addDoc, doc, onSnapshot } from 'firebase/firestore';
import './Formulaire.css';
import Footer from '../Footer';

const Formulaire = () => {
  const [prenom, setPrenom] = useState('');
  const [table, setTable] = useState('');
  const [email, setEmail] = useState('');
  const [erreur, setErreur] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const [accessError, setAccessError] = useState('');
  const [isPageActive, setIsPageActive] = useState(true);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState('');
  const [tableLimit, setTableLimit] = useState(100); // Limite par défaut
  const [showPopup, setShowPopup] = useState(false);
  const [showCartPopup, setShowCartPopup] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!prenom || !email || !table) {
      setErreur('Tous les champs sont requis.');
      return;
    }

    // Vérifier s'il y a uniquement "cart" dans le localStorage
    if (localStorage.getItem('cart') && !localStorage.getItem('userInfo') && !localStorage.getItem('articles')) {
      setShowCartPopup(true);
      return;
    }

    setErreur('');

    try {
      const clientId = generateRandomId();  // Génère un ID à 4 chiffres
      const docRef = await addDoc(collection(db, 'clients'), {
        prenom: prenom,
        table: parseInt(table, 10),
        email: email,
        idclient: clientId,  // Ajouter l'idclient dans Firestore
      });

      // Stocker les informations utilisateur dans le localStorage
      localStorage.setItem(
        'userInfo',
        JSON.stringify({
          prenom,
          table,
          email,
          id: docRef.id,  // ID Firebase
          idclient: clientId,  // Ajout de l'idclient ici
        })
      );

      console.log('Document écrit avec ID: ', docRef.id);
      setSuccess(true);
      navigate('/menu');
    } catch (error) {
      console.error('Erreur lors de l\'ajout du document: ', error);
      setErreur('Erreur lors de l\'ajout du document.');
    }
  };

  // Ajoutez cette fonction pour gérer la réponse à la popup du panier
  const handleCartPopupChoice = (accept) => {
    setShowCartPopup(false);
    
    if (accept) {
      // L'utilisateur veut continuer avec son panier existant
      // Procéder avec la soumission du formulaire
      handleFormSubmission();
    } else {
      // L'utilisateur veut vider son panier
      localStorage.removeItem('cart');
      // Procéder avec la soumission du formulaire
      handleFormSubmission();
    }
  };

  // Fonction auxiliaire pour éviter la duplication de code
  const handleFormSubmission = async () => {
    try {
      const clientId = generateRandomId();
      const docRef = await addDoc(collection(db, 'clients'), {
        prenom: prenom,
        table: parseInt(table, 10),
        email: email,
        idclient: clientId,
      });

      localStorage.setItem(
        'userInfo',
        JSON.stringify({
          prenom,
          table,
          email,
          id: docRef.id,
          idclient: clientId,
        })
      );

      console.log('Document écrit avec ID: ', docRef.id);
      setSuccess(true);
      navigate('/menu');
    } catch (error) {
      console.error('Erreur lors de l\'ajout du document: ', error);
      setErreur('Erreur lors de l\'ajout du document.');
    }
  };

  // Récupérer le numéro de table depuis l'URL
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const tableNumberFromURL = params.get('table');

  useEffect(() => {
    if (tableNumberFromURL) {
      setTable(tableNumberFromURL);  // Préremplir l'input avec le numéro de table
    }
  }, [tableNumberFromURL]);

  useEffect(() => {
    const errorParam = params.get('error');
    if (errorParam === 'access_denied') {
      setAccessError('Vous devez d\'abord remplir le formulaire pour accéder à cette page.');
    }
  }, [params]);

  useEffect(() => {
    // Vérifier le paramètre success dans l'URL
    const success = params.get('success');
    if (success === 'order_completed') {
      setSuccessMessage('Merci pour votre commande ! À bientôt !');
    }
  }, [params]);

  useEffect(() => {
    const fetchTableLimit = () => {
      const docRef = doc(db, 'settings', 'nb_table');
      const unsubscribe = onSnapshot(
        docRef,
        (docSnap) => {
          if (docSnap.exists()) {
            const limit = docSnap.data().value;
            setTableLimit(limit || 100); // Définit la limite depuis Firestore ou 100 par défaut
          }
        },
        (error) => {
          console.error('Erreur lors de l\'écoute de nb_table :', error);
        }
      );
  
      return () => unsubscribe();
    };
  
    fetchTableLimit();
  }, []);

  const handleTableChange = (e) => {
    const value = e.target.value;
    if (value === '' || (Number(value) >= 1 && Number(value) <= tableLimit)) {
      setTable(value);
      setErreur('');
    } else {
      setErreur(`Le numéro de table doit être compris entre 1 et ${tableLimit}.`);
      setTable('');
    }
  };  

  const generateRandomId = () => {
    return Math.floor(1000 + Math.random() * 9000);  // Génère un nombre entre 1000 et 9999
  };

    useEffect(() => {
        const docRef = doc(db, 'settings', 'pageStatus');
        const unsubscribe = onSnapshot(docRef, (docSnap) => {
        if (docSnap.exists()) {
            setIsPageActive(docSnap.data().isActive);
        } else {
            console.error('Le document "pageStatus" n\'existe pas.');
        }
        setLoading(false);
        }, (error) => {
        console.error('Erreur lors de l\'écoute des modifications :', error);
        setLoading(false);
        });
    
        // Nettoyage de l'écouteur lors du démontage du composant
        return () => unsubscribe();
    }, []); 
    
    useEffect(() => {
      const userInfo = localStorage.getItem('userInfo');
      const cart = localStorage.getItem('cart');
      const articles = localStorage.getItem('articles');
    
      if (userInfo && (cart || articles)) {
        setShowPopup(true);
      }
    }, []);    
  
    const handlePopupChoice = (accept) => {
    
      if (accept) {
        const cart = localStorage.getItem('cart');
        const articles = localStorage.getItem('articles');
    
        if (cart) {
          navigate('/menu');
        } else if (articles) {
          navigate('/resume');
        }
      } else {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('cart');
        localStorage.removeItem('articles');
        setShowPopup(false);
      }
    };       

    if (loading) return <div>
      <div className="dot-spinner">
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
        <div className="dot-spinner__dot"></div>
      </div>
    </div>;

    if (!isPageActive) {
      return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <h1>Page Désactivée</h1>
          <p>Cette page est actuellement désactivée. Revenez plus tard.</p>
        </div>
      );
    };

  return (
    <div className="client-form-container">
      {showPopup && (
        <div className="form-popup-overlay fade-in">
          <div className="form-popup">
            <p>On reprend là où on s'est arrêté ?</p>
            <button onClick={() => handlePopupChoice(true)} className="form-popup-btn-1">Oui on continue !</button>
            <button onClick={() => handlePopupChoice(false)} className="form-popup-btn-2">Non on recommence !</button>
          </div>
        </div>
      )}
      {showCartPopup && (
        <div className="form-popup-overlay fade-in">
          <div className="form-popup">
            <p>Je vois que vous avez déjà quelque chose dans votre panier ?</p>
            <button onClick={() => handleCartPopupChoice(true)} className="form-popup-btn-1">Continuer avec mon panier</button>
            <button onClick={() => handleCartPopupChoice(false)} className="form-popup-btn-2">Vider mon panier</button>
          </div>
        </div>
      )}
      {successMessage && <p className="client-success-message">{successMessage}</p>}
      {accessError && <p className="client-access-error">{accessError}</p>}
      {success ? (
        <h2 className="client-success-message">Maintenant, c'est le temps de commander</h2>
      ) : (
        <>
          <h2 className="client-form-title">Vos informations</h2>
          <form onSubmit={handleSubmit} className="client-form">
            <div className="client-input-group">
            <p className='your_commande'>Commande sur place</p>
              <label>Prénom :</label>
              <input
                type="text"
                value={prenom}
                onChange={(e) => setPrenom(e.target.value)}
                required
              />
            </div>
            <div className="client-input-group">
              <label>Numéro de Table (1-{tableLimit}) :</label>
              <input
                type="tel"
                value={table}
                onChange={handleTableChange}
                required
              />
            </div>
            <div className="client-input-group">
              <label>Email :</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            {erreur && <p className="client-error-message">{erreur}</p>}
            <button type="submit" className="client-submit-btn">Continuer</button>
          </form>
        </>
      )}
      <Footer />
    </div>
  );
};

export default Formulaire;